var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iptNumberBtn__div"},[_c('a-input-number',_vm._b({attrs:{"id":_vm.idIpt,"min":_vm.min,"max":_vm.max},on:{"change":_vm.iptChange}},'a-input-number',_vm.$attrs,false)),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.clickCall}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }